<app-header
  [showBackButton]="true"
  [headerData]="headerDataValues"
  (downloadClicked)="onDownloadClicked()"
  class="full"
></app-header>
<ion-content>
  <div #docxContainer></div>
</ion-content>
